var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tooltip",staticClass:"tooltip"},[_c('div',{staticClass:"tooltip__content"},[_vm._t("default")],2),_vm._v(" "),_c('a',{staticClass:"fa fa-times tooltip__close",on:{"click":_vm.hide}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6faf073e","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Tooltip.vue
// module id = 1507
// module chunks = 62